var paragraph_default = {
  "fontElementMap": "qcnZs",
  "elementSpacing": "WOBLT",
  "text": "j-JU7 WOBLT",
  "child": "eyR0C"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
